var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _circle, _circle2, _circle3, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMainSectionGraph(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 190,
    viewBox: "0 0 159 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 119,
    width: 18,
    height: 71,
    rx: 2,
    fill: "#37D881"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 134,
    width: 18,
    height: 56,
    rx: 2,
    fill: "#06813E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 85,
    width: 18,
    height: 105,
    rx: 2,
    fill: "#37D881"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 110,
    width: 18,
    height: 80,
    rx: 2,
    fill: "#06813E"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 113,
    y: 63,
    width: 18,
    height: 127,
    rx: 2,
    fill: "#37D881"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 141,
    y: 19,
    width: 18,
    height: 171,
    rx: 2,
    fill: "#06813E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 106,
    r: 6,
    fill: "#818387"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 61,
    r: 6,
    fill: "#818387"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 61,
    r: 6,
    fill: "#818387"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99999 106L38 106L66 61L100 61L137 2.00001",
    stroke: "#818387",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainSectionGraph);
export default __webpack_public_path__ + "static/media/main-section-graph.7d10b0d77628dd3956149250eff28a1a.svg";
export { ForwardRef as ReactComponent };